import { Link } from "react-router-dom";
import { Check, Plus } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import { brl, imgUrl, GENDERS } from "../../lib/api";
import { logRequest, singleMessage, waLink } from "../../lib/whatsapp";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Badges = ({ p, className = "" }) => (
  <div className={`flex flex-wrap gap-1.5 ${className}`}>
    {p.promo_price && <span className="rounded-full bg-[#D4AF37] px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-[#0B0B0C]" data-testid="badge-promo">{p.promo_label} -{p.discount_percent}%</span>}
    {p.is_launch && <span className="rounded-full border border-[#F3E5AB]/60 bg-black/60 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#F3E5AB] backdrop-blur" data-testid="badge-launch">Lançamento</span>}
    {p.best_seller && <span className="rounded-full bg-black/60 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#D4AF37] backdrop-blur">Mais vendido</span>}
    {!p.in_stock && <span className="rounded-full bg-white/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#A1A1AA] backdrop-blur">Sob consulta</span>}
  </div>
);

export const Price = ({ p, big = false }) => (
  <div className="flex flex-wrap items-baseline gap-x-3">
    <span className={`font-serif font-semibold text-[#F3E5AB] ${big ? "text-4xl" : "text-2xl"}`} data-testid="product-final-price">{brl(p.final_price)}</span>
    {p.promo_price && <span className={`text-[#A1A1AA] line-through ${big ? "text-lg" : "text-sm"}`}>{brl(p.price)}</span>}
  </div>
);

export default function ProductCard({ p }) {
  const { settings, toggleItem, isSelected } = useStore();
  const selected = isSelected(p.id);
  const [img1, img2] = p.images || [];

  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl border border-[#D4AF37]/12 bg-[#141417] transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-[#D4AF37]/45 hover:shadow-[0_18px_40px_rgba(212,175,55,0.08)]" data-testid={`product-card-${p.slug}`}>
      <Link to={`/perfume/${p.slug}`} className="relative block aspect-[4/5] overflow-hidden bg-black">
        {img1 ? (
          <>
            <img src={imgUrl(img1)} alt={p.name} loading="lazy" className={`h-full w-full object-cover transition-[transform,opacity] duration-700 group-hover:scale-105 ${img2 ? "group-hover:opacity-0" : ""}`} />
            {img2 && <img src={imgUrl(img2)} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100" />}
          </>
        ) : (
          <div className="arabesque flex h-full items-center justify-center font-serif text-xl text-[#D4AF37]/50">EMAIA</div>
        )}
        <Badges p={p} className="absolute left-3 top-3" />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">{p.brand}</p>
        <Link to={`/perfume/${p.slug}`} className="mt-1.5 font-serif text-2xl leading-tight text-[#FAF6F0] transition-colors hover:text-[#F3E5AB]" data-testid={`product-name-${p.slug}`}>{p.name}</Link>
        <p className="mt-1 text-xs text-[#A1A1AA]">{p.volume_ml}ml · {GENDERS[p.gender]}{p.family ? ` · ${p.family}` : ""}</p>
        <div className="mt-4"><Price p={p} /></div>
        <div className="mt-auto flex gap-2 pt-5">
          <a href={settings?.whatsapp ? waLink(settings.whatsapp, singleMessage(p)) : "#"} target="_blank" rel="noopener noreferrer" onClick={() => logRequest([{ id: p.id, qty: 1 }])}
            className="btn-whatsapp flex-1 px-3 py-2.5 text-xs" data-testid={`product-whatsapp-button-${p.slug}`}>
            <WhatsAppIcon className="h-4 w-4" /> Comprar pelo WhatsApp
          </a>
          <button onClick={() => toggleItem(p)} aria-label={selected ? "Remover da seleção" : "Adicionar à seleção"} title={selected ? "Remover da seleção" : "Adicionar à seleção"}
            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full border transition-colors ${selected ? "border-[#D4AF37] bg-[#D4AF37] text-[#0B0B0C]" : "border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10"}`}
            data-testid={`product-add-selection-button-${p.slug}`}>
            {selected ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
          </button>
        </div>
      </div>
    </article>
  );
}
